import { map } from "rxjs/operators";
/**
 * Created by dinesh on 13/6/17.
 */
import { Component, OnInit, OnDestroy, Renderer2, ElementRef, ViewChild } from "@angular/core";
import { AngularTokenService } from "@lakshvairav/angular-token";
import { ActivatedRoute, Router, NavigationEnd } from "@angular/router";
import { KeyValue } from "../key-value";
import { AuthorizationService } from "../authorization.service";
import { filter } from "rxjs/operators";
import { NgForm } from "@angular/forms";
declare function canEnableRollback1(): any;
declare function openRollback1(): any;
declare function init_decision_datepicker(): void;
@Component({
  selector: "app-shared-layout",
  templateUrl: "layout.component.html",
  styleUrls: ["./layout.component.css"],
})
export class LayoutComponent implements OnInit, OnDestroy {
  contact_session = [];
  hideOnTheseRoutes = false;
  selectedSession: any;
  role: string = "";
  demoLink: string;
  showRollback = false;
  rollbackText = "";
  sub_all_dec: any;
  decision_progress: boolean = false;
  isStatusPage = true;
  isContactModalOpen: boolean = false;
  isBankModalOpen = false;
  isOverviewModalOpen = false;
  isHelpModalOpen = false;
  isNotificationModalOpen: boolean = false;
  setItem;
  token: string;
  stud_team: string = "";
  current_time = "";
  time_remaining = "";
  menuOpen: boolean = false;
  current_category: String = "";
  currentYearCopyRight: number = new Date().getFullYear();
  running_quarter: String = "";
  login_notification = {
    is_notification_active: false,
    start_date_notification: "",
    start_time_notification: "",
    end_date_notification: "",
    end_time_notification: "",
    message_text: "",
  };
  error_message: any;
  dateError: boolean = false;
  notification_id = "";
  @ViewChild("notificationForm") public notificationForm: NgForm;

  update_login_notification: any;
  constructor(
    private router: Router,
    private _tokenService: AngularTokenService,
    private KeyValueService: KeyValue,
    public authService: AuthorizationService,
    private renderer: Renderer2,
    private el: ElementRef,
    private route: ActivatedRoute,
  ) {
    this.role = this.authService.getCRole();
    this.token = localStorage.getItem("accessToken");
    this.demoLink = KeyValue.demoLink; // To get the watch demo link
    this.current_category = this.authService.current_category();
  }

  isGuestUser() {
    if (this._tokenService.userSignedIn()) return false;
    else return true;
  }
  //filters the selected economy from sessions adn navigate to control page
  highlightCurrentCard() {
    console.log("Current Card..........................");
    this.removeHighlight();
    const highlight = this.router.url.split("/").pop();
    switch (highlight) {
      case "instructor-controls":
        this.addHighlight("ins-control");
        break;
      case "work-session":
        this.addHighlight("sim-setup");
        break;
      case "simulation-status":
        this.addHighlight("sim-dashboard");
        break;
      case "modify_teams":
        this.addHighlight("add-user");
        break;
      case "view-statistics":
        this.addHighlight("analytics");
        break;
      case "modify_community":
        this.addHighlight("create-team");
        break;
      case "modify-session":
        this.addHighlight("ins-control");
        break;
      case "what-if-report":
        this.addHighlight("ins-control");
        break;
      case "select-decision":
        this.addHighlight("ins-control");
        break;
      case "bank-report":
        this.addHighlight("ins-control");
        break;
      case "start-quarter-report":
        this.addHighlight("ins-control");
        break;
      case "instructor-report":
        this.addHighlight("ins-control");
        break;
      default:
        break;
    }
  }

  ngOnInit() {
    this.update_time_picker();
    console.log(this.role);
    this.highlightCurrentCard();
    this.selectedSession =
      JSON.parse(localStorage.getItem("CurrentSession")) || this.KeyValueService.getCurrentSession();
    this.KeyValueService.currentSessionUpdated$.subscribe(() => {
      this.selectedSession =
        JSON.parse(localStorage.getItem("CurrentSession")) || this.KeyValueService.getCurrentSession();
    });
    this.authService
      .get(KeyValue.api_modify_session_index)
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.contact_session = data.contactsession;
      });
    if (this.role == "Student") {
      console.log("layout comp ... init in student");
      this.authService
        .get(KeyValue.decisionstatusPath)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.time_remaining = data.time_remaining;
          this.current_time = data.current_time;
          this.stud_team = data.current_team.name;
          this.running_quarter = data.running_quarter;
          console.log("load timer 123");
          this.load_timer();
        });
    }
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.highlightCurrentCard();
    });
    // displays flash messages
    KeyValue.flash_msg.subscribe((data) => {
      const flas_msg = document.getElementById("flash_message");
      flas_msg.style.display = "block";
      flas_msg.classList.remove("success_messages");
      flas_msg.classList.remove("error_messages");
      flas_msg.classList.add(data.type);
      flas_msg.innerHTML = data.msg;
      // add aria-label to flash message
      // flas_msg.setAttribute('aria-label', 'alert, '+ data.msg);
      setTimeout(() => {
        flas_msg?.focus();
      }, 500);
      setTimeout(function () {
        flas_msg.style.display = "none";
      }, 8000);
    });

    this.sub_all_dec = this.KeyValueService.all_decisions$.subscribe((data) => {
      try {
        this.decision_progress = data.decision_started.decision_progress;
      } catch (e) {
        console.log(e);
      }
    });

    // updates the time left for student when changed by admin using websocket
    this.KeyValueService.studentTimeLeft$.subscribe(() => {
      this.authService
        .get(KeyValue.decisionstatusPath)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.time_remaining = data.time_remaining;
          this.current_time = data.current_time;
          this.stud_team = data.current_team.name;
          console.log("load timer 123");
          this.load_timer();
        });
    });
  }

  load_timer() {
    const timeLeftElement = document.getElementById("time_left");
    setTimeout(() => {
      console.log("load timer 12345");
      init_decision_datepicker();

      // Update the time left element after 1000ms
      if (timeLeftElement) {
        timeLeftElement.textContent = this.time_remaining;
      }
    }, 1000);
  }

  ngOnDestroy() {
    if (this.sub_all_dec !== undefined) {
      this.sub_all_dec.unsubscribe();
    }
  }

  // Toggle the hamburger menu
  ngAfterViewInit() {
    const hamburger = document.querySelector(".hamburger");
    const dashboardMenu = document.querySelector(".dashboard-menu");
    const dashboardMenuSection = document.querySelector(".dashboard-menu-section");
    const header = document.querySelector("header");
    if (hamburger && dashboardMenu && dashboardMenuSection) {
      // Toggle the menu on hamburger click
      hamburger.addEventListener("click", (event) => {
        event.stopPropagation(); // Prevent bubbling to document
        const isActive = hamburger.classList.toggle("is-active");
        dashboardMenu.classList.toggle("menu-active", isActive);
        if (!isActive) {
          header.classList.remove("header-active");
        }
      });

      const skipLink = document.querySelector(".skip-to-main");
      if (skipLink) {
        skipLink.addEventListener("click", (event) => {
          event.preventDefault();
          const mainContent = document.getElementById("maincontent");
          if (mainContent) {
            mainContent.scrollIntoView({ behavior: "smooth" });
            mainContent.focus();
          }
        });
      }

      // Close the menu when clicking outside the dashboardMenuSection but only if the menu is active
      document.addEventListener("click", (event) => {
        if (dashboardMenu.classList.contains("menu-active") && !dashboardMenuSection.contains(event.target as Node)) {
          this.deactivateMenu();
          header.classList.remove("header-active");
        }
      });

      // Prevent clicks inside dashboardMenuSection from closing the menu
      dashboardMenuSection.addEventListener("click", (event) => {
        event.stopPropagation();
        header.classList.remove("header-active");
      });
    }
    window.addEventListener("scroll", this.onScroll.bind(this));
  }

  //Deactivating the menu
  deactivateMenu() {
    const hamburger = document.querySelector(".hamburger");
    const dashboardMenu = document.querySelector(".dashboard-menu");
    if (dashboardMenu && hamburger) {
      dashboardMenu.classList.remove("menu-active");
      hamburger.classList.remove("is-active");
    }
    this.menuOpen = false;
  }

  // Opens a help slide-out modal from the hamburger menu
  openHelpFromMenu(modalId: string) {
    this.deactivateMenu();
    this.toggleModal(modalId);
  }

  onScroll(): void {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    const dashboardMenu = document.querySelector(".dashboard-menu");

    if (dashboardMenu && dashboardMenu.classList.contains("menu-active")) {
      if (scrollPosition >= 1) {
        this.renderer.addClass(document.querySelector("header"), "header-active");
      } else {
        this.renderer.removeClass(document.querySelector("header"), "header-active");
      }
    }
  }

  removeHighlight() {
    const listItems = this.el.nativeElement.querySelectorAll("ul.simulation-action-list li div");
    listItems.forEach((li: HTMLElement) => {
      this.renderer.removeClass(li, "bold");
    });
  }

  addHighlight(id) {
    setTimeout(function () {
      document.getElementById(id).classList.add("bold");
    }, 100);
  }

  //On click hamburger menu functions
  insControls() {
    console.log("KeyValue.insControls...");
    console.log(KeyValue.insControlsPath);
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.insControlsPath)]);
  }

  simulationSetup() {
    console.log("KeyValue.changeControlPath...");
    console.log(KeyValue.changeControlPath);
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.changeControlPath)]);
  }

  simulationStatus() {
    console.log("KeyValue.simulationStatusPath...");
    console.log(KeyValue.simulationStatusPath);
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.simulationStatusPath)]);
  }

  simulationHome() {
    this.deactivateMenu();
    this.router.navigate([KeyValue.adminPath]);
  }

  studentHome() {
    this.deactivateMenu();
    this.router.navigate([KeyValue.studentHomePath]);
  }

  modifyCommunity() {
    console.log("KeyValue.modifyCommunityPath...");
    console.log(KeyValue.modifyCommunityPath);
    this.router.navigate([this.authService.getChangePath(KeyValue.modifyCommunityPath)]);
  }

  addUserTeam() {
    console.log("KeyValue.modifyTeamPath...");
    console.log(KeyValue.modifyTeamPath);
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.modifyTeamPath)]);
  }

  changePassword() {
    console.log("KeyValue.changePasswordPath...");
    console.log(KeyValue.changePasswordPath);
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.changePasswordPath)]);
  }

  analyticsPage() {
    this.deactivateMenu();
    this.router.navigate([this.authService.getChangePath(KeyValue.viewstatisticsPath)]);
  }

  getHomeLink() {
    return [this.authService.homePath()];
  }

  openRollback() {
    openRollback1();
  }

  updateMenus() {
    this.menuOpen = !this.menuOpen;
    console.log("update menus :" + this.decision_progress);
    this.canEnableRollback();

    if (document.getElementById("session-ctrl")) {
      console.log("if status page");
      this.isStatusPage = false;
    }
  }

  canEnableRollback() {
    const status1 = canEnableRollback1();
    if (status1 == false) {
      this.showRollback = false;
      this.rollbackText = "";
      return false;
    } else {
      this.showRollback = true;
      this.rollbackText = status1;
      return true;
    }
  }

  private getFocusableElements(modal: HTMLElement): HTMLElement[] {
    return Array.from(
      modal.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'),
    ) as HTMLElement[];
  }

  private trapFocus(modal: HTMLElement): void {
    const focusableElements = this.getFocusableElements(modal);
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];

    console.log(firstFocusableElement);

    // Focus the first element
    firstFocusableElement.focus();

    // Add event listener for Tab key
    modal.addEventListener("keydown", (event: KeyboardEvent) => {
      if (event.key === "Tab") {
        if (event.shiftKey) {
          // Shift + Tab: Move focus backward
          if (document.activeElement === firstFocusableElement) {
            event.preventDefault();
            lastFocusableElement.focus();
          }
        } else {
          // Tab: Move focus forward
          if (document.activeElement === lastFocusableElement) {
            event.preventDefault();
            firstFocusableElement.focus();
          }
        }
      }
    });
  }

  toggleModalCSS(str_modal) {
    if (str_modal == "contact-modal") {
      this.isContactModalOpen = !this.isContactModalOpen;
      this.isBankModalOpen = false;
      this.isOverviewModalOpen = false;
    } else if (str_modal == "bank-modal") {
      this.isBankModalOpen = !this.isBankModalOpen;
      this.isContactModalOpen = false;
      this.isOverviewModalOpen = false;
    } else if (str_modal == "overview-modal") {
      this.isOverviewModalOpen = !this.isOverviewModalOpen;
      this.isContactModalOpen = false;
      this.isBankModalOpen = false;
    }

    if (this.isBankModalOpen == true || this.isContactModalOpen == true || this.isOverviewModalOpen == true) {
      this.isHelpModalOpen = true;
    } else {
      this.isHelpModalOpen = false;
    }
  }

  toggleModal(str_modal: string) {
    console.log("toggle modal ... ");
    console.log(window.location.pathname);
    const url1 = window.location.pathname;

    if (url1 == "/student" || url1 == "/student/home" || url1 == "/admin/control/view-statistics") {
      this.KeyValueService.update_helpUrl("stats");
    } else if (url1 == "/student/control/decision-status" || url1 == "/admin/control/decision-status") {
      console.log("1112222 sending url1 ... plan");
      const txt = (document.getElementsByClassName("student-tab active")[0] as HTMLInputElement).innerText;
      if (txt == "Loan Inputs") this.KeyValueService.update_helpUrl("loans");
      else if (txt == "Security Inputs") this.KeyValueService.update_helpUrl("securities");
      else if (txt == "Treasury Inputs") this.KeyValueService.update_helpUrl("treasuries");
      else if (txt == "Deposit Inputs") this.KeyValueService.update_helpUrl("deposits");
      else this.KeyValueService.update_helpUrl("plan");
    } else {
      this.KeyValueService.update_helpUrl("other");
    }

    // Reload contact session data when opening contact modal
    if (str_modal === "contact-modal") {
      this.authService
        .get(KeyValue.api_modify_session_index)
        .pipe(map((res) => res))
        .subscribe((data) => {
          this.contact_session = data.contactsession;
        });
    }

    this.closeAllModal();
    this.toggleModalCSS(str_modal);

    // Toggle modal visibility
    const modal = document.getElementById(str_modal);
    if (this.isHelpModalOpen) {
      modal.style.display = "block";
      document.body.classList.add("popup-open");

      // Trap focus within the modal
      // For contact-modal, defer trapFocus so Angular re-renders *ngFor
      // contact_session items (email links) before focus elements are captured
      if (str_modal === "contact-modal") {
        setTimeout(() => {
          this.trapFocus(modal);
        }, 100);
      } else {
        this.trapFocus(modal);
      }
    } else {
      modal.style.display = "none";
      document.body.classList.remove("popup-open");
    }
  }

  closeAllModal() {
    this.closeModal("bank-modal");
    this.closeModal("contact-modal");
    this.closeModal("overview-modal");
  }

  closeModal(str_modal) {
    // this.toggleModalCSS(str_modal);
    this.isHelpModalOpen = false;
    if (str_modal === "contact-modal") {
      this.isContactModalOpen = false;
    } else if (str_modal === "bank-modal") {
      this.isBankModalOpen = false;
    } else if (str_modal === "overview-modal") {
      this.isOverviewModalOpen = false;
    }
    const modal = document.getElementById(str_modal);
    if (modal.style.display === "block") {
      let triggerElement: any;
      if (str_modal == "bank-modal") {
        triggerElement = document.getElementById("how-to-play-btn");
      }
      if (str_modal == "contact-modal") {
        triggerElement = document.getElementById("contact-btn");
      }
      if (str_modal == "overview-modal") {
        triggerElement = document.getElementById("support-btn");
      }
      triggerElement?.focus();
    }
    modal.style.display = "none";
    document.body.classList.remove("popup-open");
    const supportSection = document.querySelectorAll(".db-support-icon ");
    supportSection.forEach(function (element) {
      element.classList.remove("support-icon-active");
    });
  }

  decision_timeout() {
    if (this.role != "Student") {
      this.refreshContent();
    }
  }

  refreshContent() {
    this.authService
      .get(KeyValue.api_decisionStatusUpdate)
      .pipe(map((res) => res))
      .subscribe((data) => {
        this.KeyValueService.current_decisions_update(data);
        this.KeyValueService.simulation_status_data_update(data);
      });
    // this.rollBackSession()
  }

  update_time_picker() {
    setTimeout(function () {
      init_decision_datepicker();
    }, 1000);
  }

  // sets the date and time when it is changed
  setDateTimeNotification(val, type) {
    this.dateError = false;
    this.error_message = "";
    if (type == "startDate") {
      this.login_notification.start_date_notification = val;
    }
    if (type == "endDate") {
      this.login_notification.end_date_notification = val;
    }
    if (type == "startTime") {
      this.login_notification.start_time_notification = val;
    }
    if (type == "endTime") {
      this.login_notification.end_time_notification = val;
    }
  }

  //calls when onclick of notification hamburger menu
  changeNotification() {
    this.notification_id = localStorage.getItem("notification_id") || "1";
    this.getNotificationData(this.notification_id);
    this.deactivateMenu();
    this.isNotificationModalOpen = !this.isNotificationModalOpen;

    // Toggle modal visibility
    const modal = document.getElementById("notification-modal");
    if (this.isNotificationModalOpen) {
      modal.style.display = "block";
      if (modal) this.trapFocus(modal);
    } else {
      modal.style.display = "none";
    }
  }

  closeNotificationModal() {
    this.isNotificationModalOpen = false;
    const modal = document.getElementById("notification-modal");
    modal.style.display = "none";
  }

  //calls to get the notification data
  getNotificationData(notification_id) {
    this.authService
      .get(`${KeyValue.api_update_login_notification}/${notification_id}`)
      .pipe(map((res) => res))
      .subscribe(
        (data) => {
          this.setNotificationData(data);
        },
        (error) => {
          console.log("in... api failure" + error);
        },
      );
  }

  setNotificationData(data) {
    this.login_notification.is_notification_active = data.active;
    this.login_notification.start_date_notification = new Date(data.start).toLocaleDateString("en-US", {
      timeZone: "UTC",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    this.login_notification.start_time_notification = this.formatTimeTo12Hour(data.start);
    this.login_notification.end_date_notification = new Date(data.end).toLocaleDateString("en-US", {
      timeZone: "UTC",
      month: "2-digit",
      day: "2-digit",
      year: "numeric",
    });
    this.login_notification.end_time_notification = this.formatTimeTo12Hour(data.end);
    this.login_notification.message_text = data.message || "";
  }

  // Function to convert time to 12-hour format with AM/PM
  formatTimeTo12Hour(dateString: string): string {
    const date = new Date(dateString);
    const hoursUTC = date.getUTCHours();
    const minutesUTC = date.getUTCMinutes();
    const ampm = hoursUTC >= 12 ? "PM" : "AM";
    const hours12 = hoursUTC % 12 || 12;
    const minutesPadded = minutesUTC < 10 ? "0" + minutesUTC : minutesUTC;
    return `${hours12}:${minutesPadded} ${ampm}`;
  }

  //calls when submitting the notification popup
  submitLoginNotification(notificationForm) {
    const today = new Date().getTime();
    //start time and date
    const selectedStartDate = new Date(this.login_notification.start_date_notification);
    const selectedStartTime = this.convertTo24HourFormat(this.login_notification.start_time_notification);
    const [startHours, startMinutes] = selectedStartTime.split(":").map(Number);
    selectedStartDate.setHours(startHours, startMinutes);
    const selectedStartTimestamp = selectedStartDate.getTime();
    //end time and date
    const selectedEndDate = new Date(this.login_notification.end_date_notification);
    const selectedEndTime = this.convertTo24HourFormat(this.login_notification.end_time_notification);
    const [endHours, endMinutes] = selectedEndTime.split(":").map(Number);
    selectedEndDate.setHours(endHours, endMinutes);
    const selectedEndTimestamp = selectedEndDate.getTime();
    if (this.login_notification.is_notification_active == false) {
      this.updateLoginNotification();
      return;
    }
    if (selectedStartTimestamp > today) {
      if (selectedEndTimestamp > selectedStartTimestamp) {
        if (notificationForm.valid) {
          if (this.login_notification.message_text == "" || this.login_notification.message_text == undefined) {
            this.dateError = true;
            this.error_message = "A valid message must be provided.";
          } else {
            this.updateLoginNotification();
            console.log(this.login_notification);
          }
        } else {
          console.log("Form is invalid");
        }
      } else {
        this.dateError = true;
        this.error_message = "The end date and time must be after the start date and time.";
      }
    } else {
      this.dateError = true;
      this.error_message = "The start date and time must be a future date and time.";
    }
  }

  updateLoginNotification() {
    // Format the start and end date-time strings
    const startDate = this.formatDateTime(
      this.login_notification.start_date_notification,
      this.login_notification.start_time_notification,
    );
    const endDate = this.formatDateTime(
      this.login_notification.end_date_notification,
      this.login_notification.end_time_notification,
    );

    // Create the request payload
    const payload = {
      active: this.login_notification.is_notification_active,
      start: startDate,
      end: endDate,
      message: this.login_notification.message_text,
    };

    this.authService
      .put(`${KeyValue.api_update_login_notification}/${this.notification_id}`, payload)
      .pipe(map((res) => res))
      .subscribe(
        (data) => {
          if (data.status == 201) {
            KeyValue.flash_msg_update({ msg: "Notification Saved Successfully.", type: "success_messages" });
            this.closeNotificationModal();
          } else {
            KeyValue.flash_msg_update({ msg: data.errors, type: "error_messages" });
          }
        },
        (error) => {
          console.log("Error..." + error);
        },
      );
  }

  formatDateTime = (date, time) => {
    const [month, day, year] = date.split("/");
    const time24 = this.convertTo24HourFormat(time);
    return `${year}-${month}-${day} ${time24}:00`;
  };

  convertTo24HourFormat = (time) => {
    const [timePart, modifier] = time.split(" ");
    let hours = timePart.split(":")[0];
    const minutes = timePart.split(":")[1];
    if (modifier === "PM" && hours !== "12") {
      hours = parseInt(hours, 10) + 12;
    } else if (modifier === "AM" && hours === "12") {
      hours = "00";
    }

    return `${hours}:${minutes}`;
  };

  navigateToBankReports() {
    this.router
      .navigate(["/report/viewer"], { queryParams: { init: "init", token: this.token } })
      .then(() => window.location.reload());
  }
}
